"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = exports.HttpStatusCode = void 0;
const axios_1 = __importDefault(require("axios"));
const interceptors_manager_1 = require("./interceptors/interceptors-manager");
const cache_manager_1 = require("./cache-manager/cache-manager");
const basic_interceptor_1 = require("./interceptors/interceptors/basic.interceptor");
const cache_control_interceptor_1 = require("./interceptors/interceptors/cache-control.interceptor");
const cache_buster_interceptor_1 = require("./interceptors/interceptors/cache-buster.interceptor");
const auth_interceptor_1 = require("./interceptors/interceptors/auth.interceptor");
const request_cache_interceptor_1 = require("./interceptors/interceptors/request-cache.interceptor");
const retry_interceptor_1 = require("./interceptors/interceptors/retry.interceptor");
const utils_1 = require("../utils");
var axios_2 = require("axios");
Object.defineProperty(exports, "HttpStatusCode", { enumerable: true, get: function () { return axios_2.HttpStatusCode; } });
class HttpClient {
    constructor(clientConfig) {
        this.cacheManager = cache_manager_1.CacheManagerProvider.getInstance();
        this.debugLogger = new utils_1.DebugLogger('HttpClient');
        this.instance = axios_1.default.create(clientConfig);
        this.interceptorsManager = new interceptors_manager_1.InterceptorsManager(this.instance, clientConfig);
        this.interceptorsManager.setupInterceptors([
            basic_interceptor_1.BasicInterceptor,
            cache_control_interceptor_1.CacheControlInterceptor,
            cache_buster_interceptor_1.CacheBusterInterceptor,
            auth_interceptor_1.AuthInterceptor,
            request_cache_interceptor_1.RequestCacheInterceptor,
            retry_interceptor_1.RetryInterceptor
        ]);
        this.debugLogger.log('HttpClient instance created');
    }
    async get(path, options) {
        const response = await this.instance.get(path, options);
        return this.prepareResponse(response, options);
    }
    async post(path, body, options) {
        const response = await this.instance.post(path, body, options);
        return this.prepareResponse(response, options);
    }
    async head(path, options) {
        const response = await this.instance.head(path, options);
        return this.prepareResponse(response, options);
    }
    async delete(path, options) {
        const response = await this.instance.delete(path, options);
        return this.prepareResponse(response, options);
    }
    async put(path, body, options) {
        const response = await this.instance.put(path, body, options);
        return this.prepareResponse(response, options);
    }
    async patch(path, body, options) {
        const response = await this.instance.patch(path, body, options);
        return this.prepareResponse(response, options);
    }
    prepareResponse(response, options) {
        this.debugLogger.log(`Returning ${(options === null || options === void 0 ? void 0 : options.fullResponse) ? 'full response' : 'data'} for ${response.config.url}`);
        return (options === null || options === void 0 ? void 0 : options.fullResponse) ? response : response === null || response === void 0 ? void 0 : response.data;
    }
    static get axios() {
        return axios_1.default;
    }
}
exports.HttpClient = HttpClient;
